import React, { useState, useEffect } from "react";

//import components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";
import customToasts from "../../../assets/reusableComponents/myToasts";

//functions for data fetching
import {
  deleteHouse,
  getAllHouses,
} from "../../../../redux/slices/sliceActions";
import { useSelector, useDispatch } from "react-redux";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";


const RemoveHousesModal = ({
  setShowModal,
  passedHouseInformation,
  setHouseInformation,
  propertyId,
  toastSuccess,
  toastError,
}) => {
  //redux methods
  const dispatch = useDispatch();
  // data fetched from the store
  const { houses } = useSelector((state) => state.landlordslice);

  useEffect(() => {
    console.log("passed information", passedHouseInformation);
  }, [passedHouseInformation]);

  //navigation variables
  const [isCancelButtonHovered, setIsCancelButtonHovered] = useState(false);
  const [isNextButtonHovered, setIsNextButtonHovered] = useState(false);

  //methods
  const closeModal = () => {
    setShowModal(false);
  };

  const handleCancelEdit = () => {
    closeModal();
    setHouseInformation({});
  };

  //information not passed
  const [selectedHouseToEdit, setSelectedHouseToEdit] = useState(
    houses[0]?.house_no
  );
  const confirmHouseNumberSelect = () => {
    setIsNextButtonHovered(false);
    const selectedHouse = houses.find(
      (house) => house.house_no === selectedHouseToEdit
    );
    if (selectedHouse) {
      setHouseInformation({
        houseNumber: selectedHouse.house_no,
        houseType: selectedHouse.type,
        house_id: selectedHouse._id,
        initialWaterMeterReading: selectedHouse.initial_meter_reading,
        isNewRow: false,
        meterNumber: selectedHouse.meter_no,
        occupationStatus: selectedHouse.status === "vacant" ? 0 : 1,
        rent: selectedHouse.rent,
      });
      console.log("selected house", selectedHouse);
    } else {
      customToasts.warning("House not found");
    }
  };

  const handleDeleteHouse = () => {
    customToasts
      .promise(
        dispatch(deleteHouse({ deleteId: passedHouseInformation.house_id })),
        {
          pending: "Deleting House...",
          success: "House deleted successfully",
          error: "An error occurred",
        }
      )
      .then((res) => {
        console.log("delete house response", res);
        if (res.payload?.status === "success") {
          dispatch(getAllHouses({ id: propertyId }));
          setHouseInformation({});
          closeModal();
        } else {
          customToasts.error(res.message);
        }
      });
  };

  //styles
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.7)", // Dark translucent overlay
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "white",
      padding: vh(20),
      borderRadius: vw(8),
      width: "90%", // Adapt to smaller screens
      maxWidth: vw(500),
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
      position: "relative",
      zIndex: 10000, // Ensure it's above the overlay
      animation: "fadeIn 0.3s ease",
      fontFamily: "Karla, sans-serif",
      overflowX: "hidden",
    },

    titles: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "center",
      marginBottom: vh(20),
    },
    mainTitle: {
      fontSize: vh(24),
      fontWeight: "700",
      marginBottom: vh(5),
    },
    subTitle: {
      fontSize: vh(16),
      fontWeight: "300",
      color: "#666",
    },

    propertyDescriptionDetails: {},
    propertyName: {
      position: "relative",
    },
    inputContainer: {
      display: "flex",
      justifyContent: "space-between",
      gap: vw(10),
    },
    input: {
      width: "100%",
      padding: vh(10),
      marginBottom: vh(10),
      borderRadius: vw(5),
      border: "1px solid #ccc",
      fontSize: vh(16),
    },
    select: {
      width: "100%",
      padding: vh(10),
      marginBottom: vh(10),
      borderRadius: vw(5),
      border: "1px solid #ccc",
      fontSize: vh(16),
    },

    buttonsContainer: {
      marginTop: vh(20),
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
    },
    cancelButton: {
      width: "50%",
      padding: vh(10),
      color: "white",
      borderRadius: vw(5),
      backgroundColor: "#192A3A",
      border: "none",
      cursor: "pointer",
      marginRight: vw(10),
      transition: "background-color 0.3s ease",
    },
    cancelButtonHover: {
      backgroundColor: "#B39359",
    },
    nextButton: {
      width: "50%",
      padding:vh(10),
      backgroundColor: "#621B00",
      color: "white",
      borderRadius: vw(5),
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    nextButtonHover: {
      backgroundColor: "#B39359",
    },
  };

  return (
    <div style={styles.overlay} onClick={closeModal}>
      <div
        style={{
          ...styles.modalContent,
          boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
          border: "1px solid rgba(179, 147, 89, 0.2)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {Object.keys(passedHouseInformation).length === 0 ? (
          <>
            <div
              style={{
                ...styles.titles,

                paddingBottom: vh(15),
              }}
            >
              <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
                Delete House
              </div>
              <div style={{ ...styles.subTitle, color: "#666" }}>
                Remove houses with vacancy
              </div>
            </div>
            <div
              style={{
                ...styles.roleTakersDescriptionDetails,
                padding: `${vh(20)} 0`,
              }}
            >
              <div>
                <label
                  style={{
                    color: "#192A3A",
                    fontWeight: "600",
                    marginBottom: vh(8),
                    display: "block",
                  }}
                >
                  House Number
                </label>
                <DropdownSelect
                  choices={houses.map((house) => house.house_no)}
                  defaultChoice={selectedHouseToEdit}
                  onSelect={(choice) => setSelectedHouseToEdit(choice)}
                />
              </div>
            </div>

            <div style={styles.buttonsContainer}>
              <button
                style={{
                  ...styles.cancelButton,
                  boxShadow: "0 2px 4px rgba(179, 147, 89, 0.2)",
                  ...(isCancelButtonHovered ? styles.cancelButtonHover : {}),
                }}
                onClick={handleCancelEdit}
                onMouseEnter={() => setIsCancelButtonHovered(true)}
                onMouseLeave={() => setIsCancelButtonHovered(false)}
              >
                Cancel
              </button>

              <button
                style={{
                  ...styles.nextButton,
                  boxShadow: "0 2px 4px rgba(25, 42, 58, 0.2)",
                  ...(isNextButtonHovered ? styles.nextButtonHover : {}),
                }}
                onMouseEnter={() => setIsNextButtonHovered(true)}
                onMouseLeave={() => setIsNextButtonHovered(false)}
                onClick={() => {
                  confirmHouseNumberSelect();
                }}
              >
                Confirm
              </button>
            </div>
          </>
        ) : (
          <>
            <div style={styles.stepsSlider}>
              <div style={styles.individualStepContainer}>
                <div
                  style={{
                    ...styles.titles,
                    // borderBottom: '2px solid rgba(179, 147, 89, 0.2)',
                    paddingBottom: vh(15),
                  }}
                >
                  <div style={{ ...styles.mainTitle, color: "#192A3A" }}>
                    Confirm Deletion
                  </div>
                  <div style={{ ...styles.subTitle, color: "#666" }}>
                    Are you sure you want to delete this house?
                  </div>
                </div>
                <div style={styles.roleTakersDescriptionDetails}>
                  <div
                    style={{
                      // backgroundColor: 'rgba(179, 147, 89, 0.05)',
                      padding: vh(20),
                      borderRadius: vw(12),
                      marginTop: vh(15),
                      border: "1px solid rgba(179, 147, 89, 0.2)",
                    }}
                  >
                    <div
                      style={{
                        display: "grid",
                        gap: vw(12),
                      }}
                    >
                      {[
                        ["House Number", passedHouseInformation.houseNumber],
                        ["House Type", passedHouseInformation.houseType],
                        ["Meter Number", passedHouseInformation.meterNumber],
                        [
                          "Initial Water Meter Reading",
                          passedHouseInformation.initialWaterMeterReading,
                        ],
                        [
                          "Occupation Status",
                          passedHouseInformation.occupationStatus === 0
                            ? "Vacant"
                            : "Occupied",
                        ],
                        ["Rent", passedHouseInformation.rent],
                      ].map(([label, value]) => (
                        <p
                          key={label}
                          style={{
                            margin: "0",
                            padding: vh(8),
                            borderBottom: "1px solid rgba(179, 147, 89, 0.1)",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <strong style={{ color: "#192A3A" }}>{label}:</strong>
                          <span style={{ color: "#666" }}>{value}</span>
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ ...styles.buttonsContainer, marginTop: vh(30) }}>
              <button
                style={{
                  ...styles.cancelButton,
                  boxShadow: "0 2px 4px rgba(179, 147, 89, 0.2)",
                  ...(isCancelButtonHovered ? styles.cancelButtonHover : {}),
                }}
                onClick={handleCancelEdit}
                onMouseEnter={() => setIsCancelButtonHovered(true)}
                onMouseLeave={() => setIsCancelButtonHovered(false)}
              >
                Cancel
              </button>

              <button
                style={{
                  ...styles.nextButton,
                  boxShadow: "0 2px 4px rgba(25, 42, 58, 0.2)",
                  ...(isNextButtonHovered ? styles.nextButtonHover : {}),
                }}
                onMouseEnter={() => setIsNextButtonHovered(true)}
                onMouseLeave={() => setIsNextButtonHovered(false)}
                onClick={() => {
                  handleDeleteHouse();
                }}
              >
                Confirm
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RemoveHousesModal;
